function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.0018 32.0037C24.8394 32.0037 32.0037 24.8394 32.0037 16.0018C32.0037 7.16426 24.8394 0 16.0018 0C7.16426 0 -7.89014e-07 7.16426 -1.76231e-06 16.0018C-2.73561e-06 24.8394 7.16426 32.0037 16.0018 32.0037Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.8232 13.0936C17.4412 11.4601 15.0437 12.284 14.2598 12.4693L14.9069 15.2345C15.6909 15.0521 18.191 14.6587 17.8232 13.0936Z",
  fill: "#F7931A"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.95 19.6818C16.8879 19.4623 19.8812 18.9663 19.4764 17.2473C19.0573 15.4541 16.1752 16.412 15.2373 16.6315L15.95 19.6818Z",
  fill: "#F7931A"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M0 16.0015C0 20.004 1.47385 23.6587 3.90272 26.4667L5.57042 24.799C4.64677 23.7043 3.89131 22.4671 3.34682 21.1187H5.78423C7.6629 24.8618 11.5314 27.4303 16.0043 27.4303C22.3159 27.4303 27.4331 22.3132 27.4331 16.0015C27.4331 9.6899 22.3159 4.57275 16.0043 4.57275C11.5913 4.57275 7.76552 7.07574 5.8612 10.739H3.40953C3.94833 9.44759 4.68383 8.25881 5.57327 7.20687L3.90557 5.53917C1.47385 8.34148 0 11.999 0 16.0015ZM11.5941 11.4289L11.597 11.4346C11.8849 11.3662 12.1785 11.292 12.475 11.2151L11.9419 8.94015L13.3274 8.61516L13.8491 10.8473C14.2168 10.7532 14.5874 10.6592 14.9523 10.5736L14.4335 8.35859L15.819 8.0336L16.3521 10.3085C18.1766 10.0463 19.7217 10.2658 20.2633 11.8679C20.6625 13.0396 20.3289 13.8805 19.6219 14.4764C21.0188 14.4849 22.0308 15.075 22.2788 16.8767C22.5896 19.1117 21.0958 20.081 18.798 20.7595L19.3368 23.0572L17.9514 23.3822L17.4211 21.1158C17.0619 21.2014 16.6942 21.284 16.3122 21.3638L16.8453 23.6416L15.4626 23.9666L14.9238 21.666C14.5988 21.7401 14.2682 21.8114 13.9318 21.8884L12.1301 22.3103L12.0189 20.5913C12.0189 20.5913 13.048 20.3661 13.0252 20.3547C13.4158 20.2634 13.4557 19.9556 13.4386 19.7731L12.589 16.1412C12.6404 16.1298 12.6888 16.1184 12.7344 16.107C12.6746 16.1127 12.6233 16.1241 12.5862 16.1327L11.9733 13.5385C11.8535 13.2705 11.5941 12.9854 11.0354 13.1194C11.0468 13.0966 10.029 13.356 10.029 13.356L9.68125 11.8765L11.5941 11.4289ZM7.70851 17.1162H5.86405L7.1469 19.1317H6.19189L4.68383 16.7655L3.17577 19.1317H2.22361L3.50646 17.1162H1.662V16.355H7.70851V17.1162ZM4.68668 15.266L6.209 12.8628H7.17256L5.90396 14.8555H7.71136V15.6167L1.662 15.6252V14.8555H3.4694L2.2008 12.8628H3.16437L4.68668 15.266Z",
  fill: "#F7931A"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M16.0013 2.35189C19.3539 2.35189 22.4213 3.56347 24.7988 5.56757L26.4666 3.89987C23.6585 1.47385 20.001 0 16.0013 0C12.0017 0 8.3413 1.47385 5.53613 3.90272L7.20099 5.56757C9.57854 3.56062 12.646 2.35189 16.0013 2.35189Z",
  fill: "#F7931A"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M32.0001 16.0013C32.0001 11.9988 30.5263 8.34415 28.0974 5.53613L26.4297 7.20384C28.4366 9.57854 29.6482 12.6488 29.6482 16.0013C29.6482 19.3539 28.4366 22.4213 26.4325 24.7988L28.1002 26.4666C30.5291 23.6585 32.0001 20.0038 32.0001 16.0013Z",
  fill: "#F7931A"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M26.4637 28.1001L24.796 26.4324C22.4213 28.4365 19.3539 29.6481 16.0013 29.6481C12.6488 29.6481 9.57854 28.4365 7.20384 26.4324L5.53613 28.1001C8.3413 30.5289 11.9988 32.0028 16.0013 32.0028C20.0038 32.0028 23.6585 30.5289 26.4637 28.1001Z",
  fill: "#F7931A"
});

function SvgXbtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXbtc);
export default __webpack_public_path__ + "static/media/XBTC.cbbc1784ebd0d0a65e8543969a027b15.svg";
export { ForwardRef as ReactComponent };